// extracted by mini-css-extract-plugin
export var progressBar = "_j8-0";
export var progressBarInner = "_j8-1";